import { render, staticRenderFns } from "./UnitTable.vue?vue&type=template&id=6d5f0ab6"
import script from "./UnitTable.vue?vue&type=script&lang=js"
export * from "./UnitTable.vue?vue&type=script&lang=js"
import style0 from "./UnitTable.vue?vue&type=style&index=0&id=6d5f0ab6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports